<template>
	<module-tab name="发货地" enable-flex @mounted="update" @activated="$refs.table.update()">
		<m-operate>
			<c-button color="main" @click="editHandle()">新建发货地</c-button>
		</m-operate>
		
		<c-table ref="table" height="grow">
			<c-table-column
				label="联系人"
				name="delivery_name"
				width="130"
			></c-table-column>
			
			<c-table-column
				label="联系电话/手机"
				name="delivery_mobile"
				width="180"
			></c-table-column>
			
			<c-table-column
				label="发货地址"
				name="delivery_address"
				width="400"
			>
                <template v-slot="{data}">
                    <span v-if="data.delivery_province_name">{{data.delivery_province_name}},</span>
                    <span v-if="data.delivery_city_name">{{data.delivery_city_name}},</span>
                    <span v-if="data.delivery_county_name">{{data.delivery_county_name}},</span>
                    <span v-if="data.delivery_address">{{data.delivery_address}}</span>
                </template>
			</c-table-column>
			
			<c-table-column
				label="是否启用"
				width="120"
			>
				<template #default="{data}">
					<c-switch v-model="data.state" :state-value="[2, 1]" :state-text="['启用', '禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
				</template>
			</c-table-column>
			
			<c-table-column
				label="是否默认"
				width="120"
			>
				<template #default="{data}">
					<c-switch v-model="data.is_default" :state-value="[2, 1]" :state-text="['是', '否']" @beforeChange="defaultHandle(arguments[0], arguments[1], data)"></c-switch>
				</template>
			</c-table-column>
			
			<c-table-column
				label="创建时间"
				name="create_date"
				width="140"
			>
			</c-table-column>
			
			<c-table-column
				type="button"
				label="操作"
				width="120"
			>
				<template #default="{data}">
					<c-table-button @click="editHandle(data)">编辑</c-table-button>
					<c-table-button v-if="data.is_default == 1" @click="delHandle(data)">删除</c-table-button>
				</template>
			</c-table-column>
		</c-table>
		
		<c-dialog ref="dialog" :title="editState ? '编辑发货地' : '新增发货地'" width="600" @resolve="addHandle">
			<c-form ref="form">
				<c-input type="hidden" name="id"></c-input>
				<c-form-item label="联系人" required>
					<c-input name="delivery_name"></c-input>
				</c-form-item>
				<c-form-item label="联系电话/手机" required>
					<c-input name="delivery_mobile"></c-input>
				</c-form-item>
				<c-form-item label="发货地" required>
					<c-region province-name="delivery_province_id" city-name="delivery_city_id" county-name="delivery_county_id" level="3"></c-region>
				</c-form-item>
				<c-form-item label="">
					<c-input name="delivery_address"></c-input>
				</c-form-item>
				<c-form-item label="是否启用" required v-show="!editState">
					<c-radio-group name="state">
						<c-radio value="2">启用</c-radio>
						<c-radio value="1">禁用</c-radio>
					</c-radio-group>
				</c-form-item>
				<c-form-item label="是否默认" required v-show="!editState">
					<c-radio-group name="is_default">
						<c-radio value="2">是</c-radio>
						<c-radio value="1">否</c-radio>
					</c-radio-group>
				</c-form-item>
			</c-form>
		</c-dialog>
	</module-tab>
</template>

<script>
	export default {
		data() {
			return {
				editState: false
			}
		},
		
		methods: {
			update() {
				this.$refs.table.load({
					url: '/delivery_address/list'
				});
			},
			
			stateHandle(state, next, data) {
				this.request({
					url: '/delivery_address/state',
					data: {
						id: data.id,
						state: state ? 1 : 2
					},
					success: () => {
						next();
					}
				})
			},
			
			defaultHandle(state, next, data) {
				if(data.is_default == 2){
					return ;
				}
				this.request({
					url: '/delivery_address/default',
					data: {
						id: data.id
					},
					success: () => {
						next();
						this.$refs.table.update();
					}
				})
			},
			
			editHandle(data) {
				this.editState = !!data;
				this.$refs.form.clear();
				this.$refs.form.set(data || {
					state: 2, is_default: 1
				});
				this.$refs.dialog.open();
			},
			
			delHandle(data) {
				this.$confirm({
					message: '确定要删除【' + data.delivery_name + '】吗？',
					resolve: () => {
						this.request({
							url: '/delivery_address/remove',
							data: {
								id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									type: 'success',
									message: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			
			addHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: this.editState ? '/delivery_address/edit' : '/delivery_address/add',
					rule: {
						delivery_name: '请填写联系人',
						delivery_mobile: '请填写联系方式',
                        delivery_province_id: '请选择发货地所在省份',
                        delivery_city_id: '请选择发货地所在城市',
                        delivery_county_id: '请选择发货地所在区县',
						delivery_address: '请填写发货地详细地址',
						state: '请选择是否启用',
						is_default: '请选择是否默认'
					},
					success:() => {
						next();
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.$refs.table.update();
					}
				});
			}
		}
	}
</script>

<style>
</style>